import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";

import Modal from "../../Modal";
import { targetChecked } from "../../../shared/helpers";
import {getAvailableTime, postNewAlarmId, updateAvailableTime} from "../../../api/openApi";

import styles from './AddAlarmIdModalForm.module.scss';
import moment from "moment";

const AddAlarmIdModalForm = ({ onCloseForm, formData, setFormData, serial }) => {
    const [formSuccessfullySent, setFormSuccessfullySent] = useState(false);
    const [checkboxes, setCheckboxes] = useState({ first_checkbox: false, second_checkbox: false });
    const [estimatedDownloadTime, setEstimateTime] = useState(0);
    const [availableTime, setTime] = useState(0);
    const { channel, stream_type, before, after } = formData;

    const handleChangeCheckbox = ({ target: { name } }) => {
        setCheckboxes((prevState) => ({ ...prevState, [name]: !prevState[name] }));
    }

    // @ts-ignore
    useEffect(() => getDeviceCamerasAvailableTime(serial), []);

    const getDeviceCamerasAvailableTime = async (serial) => {
        const res = await getAvailableTime(serial);
        setTime(res.available_time);
        return;
    }

    useEffect(() => {
        let channelString;
        if (checkboxes.first_checkbox && checkboxes.second_checkbox) {
            channelString = "1,2";
        } else if (checkboxes.first_checkbox) {
            channelString = "1";
        } else if (checkboxes.second_checkbox) {
            channelString = "2";
        } else {
            channelString = "";
        }
        setFormData((prevState) => ({ ...prevState, channel: channelString }));
    }, [checkboxes])

    useEffect(() => calcEstimatedTime(), [channel, stream_type, before, after]);

    const calcEstimatedTime = () => {
        let isHighDefined = stream_type == '1' ? 2 : 1;
        let channelsCount = channel
            .split(',')
            .filter((channel_name) => channel_name.trim())
            .length;

        const neededDownloadTime = (Number(before) + Number(after)) * (Number(channelsCount) * isHighDefined);
        setEstimateTime(neededDownloadTime);
    }

    const formatDuration = (seconds) => {
        const duration = moment.duration(seconds, 'seconds');
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const secs = duration.seconds();

        const hoursStr = hours > 0 ? `${hours}h ` : '';
        const minutesStr = minutes > 0 ? `${minutes}m ` : '';
        const secsStr = secs > 0 ? `${secs}s` : '';

        return `${hoursStr}${minutesStr}${secsStr}`.trim();
    };

    const handleChange = ({ target: { name, value } }) => {
        setFormData((prevState) => ({ ...prevState, [name]: value }));
    };

    const submitForm = async (event) => {
        event.preventDefault();
        const res = await postNewAlarmId(formData);
        if (res.success) {
            const res = await updateAvailableTime(serial, estimatedDownloadTime);
            setFormSuccessfullySent(true);
            setTimeout(() => { onCloseForm() }, 3000);
        }
    }

    return (
        <Modal>
            <div className={styles.modalContent} style={{ width: "30vw", padding: '30px 50px' }}>
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderRow}>
                        <h2>Downloading the alarm</h2>
                        <button onClick={onCloseForm} role="close modal button">X</button>
                    </div>
                </div>
                {formSuccessfullySent ? (
                    <>
                        <h2 className={styles.center_text}>Done!</h2>
                        <p className={styles.center_text}>The form has been submitted successfully.</p>
                    </>
                ) : (
                    <form onSubmit={submitForm}>
                        <p className={styles.labelTitle}>Channel:</p>
                        <label className={styles.container}>1
                            <input
                                type="checkbox"
                                name="first_checkbox"
                                checked={checkboxes.first_checkbox}
                                onChange={handleChangeCheckbox}
                            />
                            <span className={styles.checkmark}></span>
                        </label>
                        <label className={styles.container}>2
                            <input
                                type="checkbox"
                                name="second_checkbox"
                                checked={checkboxes.second_checkbox}
                                onChange={handleChangeCheckbox}
                            />
                            <span className={styles.checkmark}></span>
                        </label>
                        <br />
                        <label htmlFor="file_type" className={styles.labelTitle}>File type:</label>
                        <br />
                        <select
                            id="file_type"
                            name="file_type"
                            value={formData.file_type}
                            onChange={handleChange}
                            className={styles.styledInput}
                        >
                            <option value="9">Still Image</option>
                            <option value="1">Video</option>
                        </select>
                        <br />
                        <label htmlFor="stream_type" className={styles.labelTitle}>Stream type:</label>
                        <br />
                        <select
                            id="stream_type"
                            name="stream_type"
                            value={formData.stream_type}
                            onChange={handleChange}
                            className={styles.styledInput}
                        >
                            <option value="2">Standard Resolution</option>
                            <option value="1">High Resolution</option>
                        </select>
                        <br />
                        <div className={styles.flex}>
                            <div>
                                <label htmlFor="before" className={styles.labelTitle}>Before event:</label>
                                <br />
                                <input
                                    type="number"
                                    id="before"
                                    name="before"
                                    value={formData.before}
                                    onChange={handleChange}
                                    placeholder="1-60 sec"
                                    className={`${styles.styledInput} ${styles.seconds}`}
                                    min="1"
                                    max="60"
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="after" className={styles.labelTitle}>After event:</label>
                                <br />
                                <input
                                    type="number"
                                    id="after"
                                    name="after"
                                    value={formData.after}
                                    onChange={handleChange}
                                    placeholder="1-60 sec"
                                    className={`${styles.styledInput} ${styles.seconds}`}
                                    min="1"
                                    max="60"
                                    required
                                />
                            </div>
                        </div>
                        <div>
                            {availableTime && <p className={styles.labelTitle}>Time Available:{moment.utc(moment.duration(availableTime,'seconds').as('milliseconds')).format('HH:mm:ss')}</p>}
                            <p className={styles.labelTitle}>Time Needed for download:{formatDuration(estimatedDownloadTime)}</p>
                        </div>
                        <hr />
                        <div className={styles.buttons_block}>
                            <Button
                                type="submit"
                                variant="contained"
                            >
                                Create
                            </Button>
                            <Button
                                type={'button'}
                                variant="outlined"
                                onClick={onCloseForm}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>
                )}

            </div>
        </Modal>
    )
}

export default AddAlarmIdModalForm;
